export default {"src":"/_next/static/media/section_courses_2.41c3bc98.svg","height":435,"width":1031};